<template>
	<div class="cont_pont">
		<div class="cpt_pc" v-if="!isPhone">
			<div class="ad_p1">徐州市交通控股集团</div>
			<div class="ad_p2">地&nbsp;&nbsp;&nbsp;址：{{comInfo.address}}</div>
			<div class="ad_p2">邮&nbsp;&nbsp;&nbsp;箱：{{comInfo.email}}</div>
			<img class="map_img" v-show="comInfo.images" :src="staticImg+comInfo.images">
		</div>
		<div class="cpt_ph" v-if="isPhone">
			<div class="ad_p1">徐州市交通控股集团</div>
			<div class="ad_p2">地&nbsp;&nbsp;&nbsp;址：{{comInfo.address}}</div>
			<div class="ad_p2">邮&nbsp;&nbsp;&nbsp;箱：{{comInfo.email}}</div>
			<img class="map_img" v-show="comInfo.images" :src="staticImg+comInfo.images">
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			comInfo: {},
			staticImg: this.$staticImg,
            isPhone: this.$isMobile,
		}
	},
	created() {
		this.abouts();
	},
	methods: {
		async abouts() {
			const res = await this.$api.abouts();
			if (res.code == 1) {
				this.comInfo = res.data;
			}
		},
	}
}
</script>

<style lang="scss">
.cont_pont {
	.cpt_pc {
		.ad_p1 {
			font-size: 22px;
			margin-top: 20px;
			margin-bottom: 30px;
		}
		.ad_p2 {
			font-size: 16px;
			color: #474747;
			margin-bottom: 10px;
		}
		.map_img {
			width: 100%;
			margin-top: 50px;
		}
	}
    .cpt_ph{
        padding: 0.35rem;
        .ad_p1 {
			font-size: 0.5rem;
			margin-top: 0.3rem;
			margin-bottom: 0.73rem;
		}
		.ad_p2 {
			font-size: 0.37rem;
			color: #474747;
			margin-bottom: 0.25rem;
		}
		.map_img {
			width: 100%;
			margin-top: 0.7rem;
		}
    }
}
</style>